import { useFlag } from '@wix/da-react-context/pkg/flags/hooks/useFlag';
import React from 'react';
import DesktopProfileVideoGak from './gak/DesktopProfileVideo';
import DesktopProfileVideoNitro from './nitro/DesktopProfileVideo';
const DesktopProfileVideo = ({ safety ='off'  })=>{
    const isDaAds = useFlag('ads_da');
    if (isDaAds) {
        return /*#__PURE__*/ React.createElement(DesktopProfileVideoGak, {
            safety: safety
        });
    }
    return /*#__PURE__*/ React.createElement(DesktopProfileVideoNitro, {
        safety: safety
    });
};
DesktopProfileVideo.displayName = 'DesktopProfileVideo';
export default DesktopProfileVideo;
